import {
  Flex,
  Text,
  Image,
  TextInput,
  Box,
  Modal,
  Loader,
  Anchor,
} from "@mantine/core";
import Main_Logo from "../../assets/logo/Logo.svg";
import { useNavigate, useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import YOU_WON from "../../assets/logo/you_won.svg";
import WELL_DONE from "../../assets/logo/well-done.svg";
import AMAZON_CARD from "../../assets/logo/amazon-card.svg";
import { useDisclosure } from "@mantine/hooks";
import GAME_OVER from "../../assets/logo/game_over.svg";
import RETRY from "../../assets/logo/retry.svg";
import { AwesomeButton } from "react-awesome-button";
import "./result.css";
import GIFT from "../../assets/logo/gift.svg";
import Confetti from "react-confetti";
import { useForm } from "@mantine/form";
import TajMahal from "../../assets/logo/TajMahal.svg";
import GatewayOfIndia from "../../assets/logo/Gateway_of_India.svg";
import NachiFalls from "../../assets/logo/nachi_falls.svg";
import Liberty from "../../assets/logo/statue_of_liberty.svg";
import Colosseum from "../../assets/logo/colosseum.svg";
import Petronas from "../../assets/logo/petronas.svg";
import { motion } from "framer-motion";
import Error from "../Error/Error";

const Result = () => {
  const userAgent = navigator.userAgent;
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [emailPhoneList, setEmailPhoneList] = useState([]);
  const [isUniqueDetails, setIsUniqueDetails] = useState(false);
  const [responses, setResponses] = useState({});
  const [others, setOthers] = useState({});

  const navigate = useNavigate();
  const navigateOnButtonPress = () => {
    navigate("/start");
  };

  const [opened, { open, close }] = useDisclosure(false);
  const [showConfetti, setShowConfetti] = useState(true);

  const form = useForm({
    initialValues: { name: "", email: "", phone: "" },

    validate: {
      name: (value) =>
        value.length < 2 ? "Name must have at least 2 letters" : null,
      email: (value) => (/^\S+@\S+\.\S+$/.test(value) ? null : "Invalid email"),

      phone: (value) =>
        value.length < 10 ? "Phone must have at least 10 Number" : null,
    },
  });
  // console.log(responses);

  //Test Sheet
  // const scriptURL =
  //   "https://script.google.com/macros/s/AKfycbx-tf20ipwcMRD566bL_-bbkUEdoZ8qkHG08Kn-VPAtWfA9pt9Rdu5i_201HDWbMH-7rQ/exec";

  //Actual Production sheet
  const scriptURL =
    "https://script.google.com/macros/s/AKfycbypVmveseI9ZPOmF41IQY8Z_qvRB2lc48Q_Z-LWTLpwwyo7atik60_DnInFzdkdrVYTYA/exec";

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    const { values, errors, isValid } = form;

    if (isValid) {
      const { email, phone } = values;

      const exists = emailPhoneList.some(
        (entry) => entry.email === email || entry.phone === phone
      );

      if (!exists) {
        // Add new entry to emailPhoneList
        const newEntry = { email, phone };
        const updatedList = [...emailPhoneList, newEntry];
        setEmailPhoneList(updatedList);

        localStorage.setItem("emailPhoneList", JSON.stringify(updatedList));

        // Proceed with form submission
        const formData = new FormData();
        formData.append("name", values.name);
        formData.append("email", values.email);
        formData.append("phone", values.phone);

        // Append each type of response separately
        responses.forEach((item) => {
          Object.keys(item).forEach((questionKey) => {
            formData.append(questionKey, item[questionKey]);
          });
        });

        formData.append("meta-data", userAgent);

        fetch(scriptURL, {
          method: "POST",
          body: formData,
        })
          .then(() => {
            setIsUniqueDetails(true);
            open();
          })
          .catch((error) => {
            alert(
              "Sorry! Something seems to be wrong, please try again later!"
            );
            console.error("Error!", error.message);
          })

          .finally(() => setLoading(false));
      } else {
        // Email or phone already exists
        setIsUniqueDetails(false);
        setLoading(false);
        open();
      }
    } else {
      setLoading(false);
    }
  };

  const saveCustomButtonStyles = (styles) => {
    localStorage.setItem("customButtonStyles", styles);
  };

  useEffect(() => {
    if (location.state && location.state.currQuestionIndex !== undefined) {
      setResponses(
        location.state.questions.map((q) => {
          const response = {};
          response[q.key] = q.response;
          if (Array.isArray(q.response)) {
            //remove unnesessary "Other (please specify)" field from response array
            // q.response.splice(q.response.indexOf("Other (please specify)"), 1);
            q.response = q.response.filter(
              (item) => item !== "Other (please specify)"
            );
            response[q.key] = q.response.join(", ");
          }
          if (q.others !== "" && q.type === "radio") {
            //check if a radio button response then inculde only other field
            response[q.key] = `Other - ${q.others}`;
          }
          if (q.others !== "" && q.type === "checkbox") {
            //check if a checkbox response then inculde both response & others field
            response[q.key] +=
              response[q.key] === ""
                ? `Other - ${q.others}`
                : `, Other - ${q.others}`;
          }
          return response;
        })
      );
    }
  }, [location.state]);

  useEffect(() => {
    const storedData = localStorage.getItem("emailPhoneList");
    if (storedData) {
      setEmailPhoneList(JSON.parse(storedData));
    }
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowConfetti(false);
    }, 6000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const customButtonStyles = localStorage.getItem("customButtonStyles");
    if (customButtonStyles) {
      const styleTag = document.createElement("style");
      styleTag.innerHTML = customButtonStyles;
      document.head.appendChild(styleTag);
    }
  }, []); // Run only once on component mount

  const customButtonStyles = `
    .custom-awesome-button {
  --button-default-height: 60px;
  --button-default-border-radius: 14px;
  --button-horizontal-padding: 130px;
  --button-raise-level: 10px;
  --button-hover-pressure: 2;
  --transform-speed: 0.185s;
  --button-primary-color: #d4dc64;
  --button-primary-color-dark: #aab328;
  --button-primary-color-hover: #aab328;
  --button-primary-border: none;
  margin-top: 10%;
    }
    .custom-awesome-button-ok {
  --button-default-height: 60px;
  --button-default-border-radius: 14px;
  --button-horizontal-padding: 100px;
  --button-raise-level: 10px;
  --button-hover-pressure: 2;
  --transform-speed: 0.185s;
  --button-primary-color: #d4dc64;
  --button-primary-color-dark: #aab328;
  --button-primary-color-hover: #aab328;
  --button-primary-border: none;
  margin-top: 10%;
    }
  `;

  useEffect(() => {
    saveCustomButtonStyles(customButtonStyles);
  }, [responses]);

  const handleDuplicateDetails = () => {
    close();
  };

  const handleClose = () => {
    close();
    form.reset({
      name: "",
      email: "",
      phone: "",
    });
    window.history.replaceState({}, "");
    setResponses({});
    navigate("/start");
  };

  useEffect(() => {
    // Simulate loading delay for demonstration purposes
    const timeout = setTimeout(() => {
      setLoading(false); // Set loading to false after timeout (simulating data loading)
    }, 1000); // Adjust timeout duration as needed

    return () => clearTimeout(timeout); // Cleanup on component unmount
  }, []);

  if (loading) {
    return (
      <Flex justify={"center"} align={"center"} h={"100%"}>
        <Loader color="#d4dc64" type="dots" />
      </Flex>
    );
  }

  if (
    location?.state?.currQuestionIndex + 1 !==
    location?.state?.questions?.length
  ) {
    return <Error message="Oops! You have reached an unreachable page." />;
  }

  return (
    <Flex
      flex={1}
      align="center"
      justify="space-around"
      direction="column"
      style={{
        backgroundImage: "linear-gradient(to bottom, #006C85, #00323D)",
      }}
      py={20}
      px={20}
    >
      <Box
        w={"100vw"}
        h={"100%"}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          overflow: "hidden",
          zIndex: 0,
        }}
      >
        <motion.div
          animate={{ x: -40, y: 4, rotate: -4 }}
          transition={{ ease: "easeInOut", duration: 1, delay: 1 }}
          style={{
            position: "absolute",
            top: 0,
            bottom: 0,
            right: -110,
          }}
        >
          <Image src={Petronas} alt="Petronas" w={150} />
        </motion.div>
        <motion.div
          animate={{ x: 80, y: -40, rotate: -40 }}
          transition={{ ease: "easeInOut", duration: 1, delay: 1 }}
          style={{
            position: "absolute",
            top: 60,
            left: -150,
          }}
        >
          <Image src={Colosseum} alt="Colosseum" w={150} />
        </motion.div>
        <motion.div
          animate={{ x: 90, y: 10, rotate: 6 }}
          transition={{ ease: "easeInOut", duration: 1, delay: 1 }}
          style={{
            position: "absolute",
            top: 220,
            left: -150,
          }}
        >
          <Image src={NachiFalls} alt="NachiFalls" w={150} />
        </motion.div>
        <motion.div
          animate={{ x: -50, y: 10, rotate: -10 }}
          transition={{ ease: "easeInOut", duration: 1, delay: 1 }}
          style={{
            position: "absolute",
            top: 240,
            right: -130,
          }}
        >
          <Image src={Liberty} alt="Liberty" w={150} />
        </motion.div>
        <motion.div
          animate={{ x: -70, y: -50, rotate: -20 }}
          transition={{ ease: "easeInOut", duration: 1, delay: 1 }}
          style={{
            position: "absolute",
            // top: 10,
            right: -100,
            bottom: -50,
          }}
        >
          <Image src={GatewayOfIndia} alt="GatewayOfIndia" w={150} />
        </motion.div>
        <motion.div
          animate={{ x: 60, y: -10, rotate: 20 }}
          transition={{ ease: "easeInOut", duration: 1, delay: 1 }}
          style={{
            position: "absolute",
            // top: 120,
            left: -120,
            bottom: 0,
          }}
        >
          <Image src={TajMahal} alt="Taj Mahal logo" w={150} />
        </motion.div>
      </Box>
      {showConfetti && <Confetti />}
      <Flex direction="column" align="center" style={{ zIndex: 1 }}>
        <Anchor
          href="https://www.dreamcatcherz.net/"
          target="_blank"
          style={{
            width: "100%",
            height: "auto",
          }}
        >
          <Image src={Main_Logo} style={{ height: "auto" }} align="center" />
        </Anchor>
        <Image src={WELL_DONE} w={"80%"} />
        <Text
          c="#aab328"
          style={{
            fontSize: 16,
          }}
        >
          You've just won an exclusive gift card!
        </Text>
        <Image src={AMAZON_CARD} w={"60%"} />
        <Text
          c="#CCD9DC"
          style={{
            fontSize: 36,
            // fontFamily: "Grandstander-Light",
            fontStyle: "italic",
          }}
        >
          ₹100
        </Text>
      </Flex>
      <Flex direction="column" style={{ zIndex: 1 }}>
        <Text c="#ffffff" py={8} align="center">
          Fill up your details, and we'll send it over to you!
        </Text>
        <form method="post" name="google-sheet" onSubmit={form.onSubmit(open)}>
          <TextInput
            label={
              <span style={{ color: "#ffffff", marginLeft: 5, fontSize: 16 }}>
                Name
              </span>
            }
            name="name"
            withAsterisk
            placeholder="Enter name"
            color="#ffffff"
            size="lg"
            type="text"
            styles={{
              input: {
                backgroundColor: "#023D47",
                borderColor: "#0096B8",
                borderRadius: "12px",
                color: "#ffffff",
              },
            }}
            {...form.getInputProps("name")}
          />
          <TextInput
            mt="sm"
            label={
              <span style={{ color: "#ffffff", marginLeft: 5, fontSize: 16 }}>
                Email Address
              </span>
            }
            withAsterisk
            placeholder="example@gmail.com"
            size="lg"
            name="email"
            type="email"
            onChange={(e) => setEmail(e.target.value)}
            styles={{
              input: {
                backgroundColor: "#023D47",
                borderColor: "#0096B8",
                borderRadius: "12px",
                color: "#ffffff",
              },
            }}
            {...form.getInputProps("email")}
          />
          <TextInput
            type="tel"
            mt="sm"
            label={
              <span style={{ color: "#ffffff", marginLeft: 5, fontSize: 16 }}>
                Phone Number
              </span>
            }
            withAsterisk
            placeholder="+91"
            maxLength={10}
            name="phone"
            onChange={(e) => setPhone(e.target.value)}
            // hideControls
            size="lg"
            styles={{
              input: {
                backgroundColor: "#023D47",
                borderColor: "#0096B8",
                borderRadius: "12px",
                color: "#ffffff",
              },
            }}
            {...form.getInputProps("phone")}
          />
        </form>
        <AwesomeButton
          className="custom-awesome-button"
          onPress={handleSubmit}
          disabled={!form.isValid()}
        >
          <Text size="xl" fw={600} c="#004251">
            {loading ? "Loading..." : "SUBMIT"}
          </Text>
        </AwesomeButton>
        {isUniqueDetails ? (
          <Modal
            opened={opened}
            centered
            onClose={close}
            withCloseButton={false}
            radius={20}
          >
            <Flex align="center" direction="column" p={20}>
              <Text
                size="xl"
                fw="bold"
                variant="gradient"
                gradient={{
                  from: "#004251",
                  to: "#109BBB",
                  deg: 180,
                }}
                style={{ fontSize: 26 }}
              >
                Check Your Email!
              </Text>
              <Image src={GIFT} h={170} w={170} />
              <Text ta="center" style={{ fontSize: 20, fontWeight: "bold" }}>
                Your prize flies into your inbox within 24 hours!{" "}
              </Text>
              <AwesomeButton
                className="custom-awesome-button-ok"
                onPress={handleClose}
              >
                <Text size="xl" c="#004251" fw={600}>
                  Ok
                </Text>
              </AwesomeButton>
            </Flex>
          </Modal>
        ) : (
          <Modal
            opened={opened}
            centered
            onClose={close}
            withCloseButton={false}
            radius={20}
          >
            <Flex align="center" direction="column" p={20}>
              <Text
                size="xl"
                fw="bold"
                variant="gradient"
                gradient={{
                  from: "#004251",
                  to: "#109BBB",
                  deg: 180,
                }}
                style={{ fontSize: 26 }}
              >
                Oops..
              </Text>
              <Text ta="center" style={{ fontSize: 20, fontWeight: "bold" }}>
                Email or phone already in use. Please use a different one.
              </Text>
              <AwesomeButton
                className="custom-awesome-button-ok"
                onPress={handleDuplicateDetails}
              >
                <Text size="xl" c="#004251" fw={600}>
                  Ok
                </Text>
              </AwesomeButton>
            </Flex>
          </Modal>
        )}
      </Flex>
    </Flex>
  );
};

export default Result;
